export const getDomain = () => {
	const url = new URL(window.location.href);
	return url.hostname;
};

export const getSubdomain = () => {
	const url = new URL(window.location.href);
	return url.hostname.split('.').slice(-2).join('.');
};

export const generateURL = (): string => {
	const protocol = window.location.protocol;
	const hostName = window.location.hostname;
	const path = window.location.pathname;

	const params = new URLSearchParams(window.location.search);
	const testURL = params.get('test_url');

	if (testURL && process.env.VERCEL_ENV !== 'production') {
		// eslint-disable-next-line no-console
		console.log('Setting test URL', testURL);
		return testURL;
	}

	let url = `${protocol}//${hostName}${path}`;
	if (url === 'http://localhost/') url = 'localhost';

	return url;
};
